module.exports = __webpack_public_path__ + "static/media/checked.040bef70.png";